import arunabha from '../public/arunabha.png'
import sanjana from '../public/sanjana.jpeg'
export const Blockchain = [
    {
        id: 1,
        name: 'Arunabha Dhal',
        image_url:arunabha,
        description : 'Blockchain',       
    },
    {
        id: 2,
        name: 'Sai Sanjana Reddy Algubelly',
        image_url:sanjana,
        description : 'Blockchain',       
    }
]
